import envStore, { publicUrl } from '@utils/env';

export const ZOOM_MAX = 19;
export const ZOOM_MIN = 5;
export const MINPAGESIZE = 40; // xem như là page size current cơ bản nhất
export const MINPAGESIZE1 = 120;
export const MINPAGESIZE2 = 560;
export const DELAY_HTOOLTIP = 250;
export const TIME_ZONE = new Date().getTimezoneOffset() / -60;

export const PHONE_REG_EXP = /(^$)|(^((([0][1,2])([0-9]{9}))|(([0][3,5,6,7,8,9])([0-9]{8})))$)/; // chưa sài tới check này, do kỹ quá...
export const PHONE_REG_EXP_EXTEND = /(^$)|(^(([0])([0-9]{8,10}))$)/; // Bắt đầu là 0, dài từ 9-11 số
export const NUMBER_REG_EXP = /^[a-zA-Z0-9]+$/;
export const SPECIAL_REG_EXP = /^[^!@#$%^&*+=<>:;|~]*$/;

export const KEY_SHIFT = 16;
export const KEY_ESCAPE = 27;
export const KEY_ENTER = 13;
export const INTERVAL_DTOKEN = 60000 * 5;
export const COMPANY_NAMES = [
  {
    value: 'AnhDuong',
    label: 'Ánh Dương'
  },
  {
    value: 'BinhMinh',
    label: 'Bình Minh'
  }
];

// cài đặt khai báo nàu sắc cho style của toàn web
// nếu up lại web thì chỉnh sửa version hoặc các thông số khác cần thiết cho bản up (dành cho AD và BM)
export enum CONFIG_AD {
  keyWeb = 'OM',
  backGround = 'adsun_bg',
  activeBGMain = 'adsun_at_bg_main',
  activeBGSub = 'adsun_at_bg_sub',
  activeBD = 'adsun_at_bd',
  hoverBD = 'adsun_hv_bd',
  hoverColor = 'adsun_hv_color',
  mainText = 'adsun_at_text',
  version = 'V.1.2.48', // dùng khi up web check version với server
  versionDisplay = 'V.1.2.48', // dùng khi hiển thị dưới header cho test biết
  lastUpdate = '06/04/2026',
  nameDL = 'ADSUN'
}

export enum CONFIG_BM {
  keyWeb = 'OMDEV',
  backGround = 'bm_bg',
  activeBGMain = 'bm_at_bg_main',
  activeBGSub = 'bm_at_bg_sub',
  activeBD = 'bm_at_bd',
  hoverBD = 'bm_hv_bd',
  hoverColor = 'bm_hv_color',
  mainText = 'bm_at_text',
  version = 'V.1.1.52', // dùng khi up web check version với server
  versionDisplay = 'V.1.2.139', // dùng khi hiển thị dưới header cho test biết
  lastUpdate = '11:00 06/04/2026', // dd/mm/yyyy
  nameDL = 'Bình Minh'
}

export const CONFIG_WEBSITE = envStore.nameweb == 'anhduongom' ? CONFIG_AD : CONFIG_BM; // cấu hình chính khi build web, sử dụng ở các trang cần lấy cấu hình

// xử lý image bình thường
const setImageValue = (src: string) => {
  const imageCar = new Image();
  imageCar.src = src;
  return imageCar;
};

export const CONFIG_IMGs = {
  Example: setImageValue(`${publicUrl}/logo_adsun_only.png`)
};

// Trạng thái phân loại đơn hàng tab ql đơn
export const AllNotComplete = ['New', 'NotApproved', 'Assigned', 'Approved', 'Processing', 'Pending'];
export const ConfirmWait = ['New', 'NotApproved', 'Assigned', 'Approved'];
export const UnSuccessOrder = ['New', 'NotApproved', 'Assigned', 'Approved', 'Processing', 'Pending'];
export const InProcess = ['Processing'];
export const InHold = ['Pending'];
export const Success = ['Complete'];
export const SuccessOrder = ['Complete', 'Cancel'];
export const Cancel = ['Cancel'];

export interface ISelectOption {
  label: any;
  value: any;
  companyId?: any;
  serial?: any;
}

// All value select
export const AllOptionValue: ISelectOption = {
  label: 'Select.AllOption',
  value: -1
};

// Ds các loại gói cước
export const SPACK_OPTIONS = [
  {
    Name: 'Không chọn',
    Data: undefined
  },
  {
    Name: 'G0',
    Data: 'G0'
  },
  {
    Name: 'G40',
    Data: 'G40'
  },
  {
    Name: 'G3H',
    Data: 'G3H'
  },
  {
    Name: 'G10',
    Data: 'G10'
  },
  {
    Name: 'G30',
    Data: 'G30'
  },
  {
    Name: 'G60',
    Data: 'G60'
  },
  {
    Name: 'G90',
    Data: 'G90'
  },
  {
    Name: 'G120',
    Data: 'G120'
  },
  {
    Name: 'G6H',
    Data: 'G6H'
  },
  {
    Name: 'Gdemo',
    Data: 'Gdemo'
  },
  {
    Name: 'GVT30',
    Data: 'GVT30'
  },
  {
    Name: 'GVT60',
    Data: 'GVT60'
  },
  {
    Name: 'G24H-CJVINA',
    Data: 'G24H-CJVINA'
  },
  {
    Name: 'GVT90',
    Data: 'GVT90'
  }
];

// DS loại xe
export const TYPE_VEHICLE = [
  {
    value: 0,
    label: 'Xe khách'
  },
  {
    value: 1,
    label: 'Xe bus'
  },
  {
    value: 2,
    label: 'Xe 7 chỗ'
  },
  {
    value: 3,
    label: 'Xe 16 chỗ'
  },
  {
    value: 4,
    label: 'Xe tải'
  },
  {
    value: 5,
    label: 'Taxi'
  },
  {
    value: 6,
    label: 'Taxi Tải'
  },
  {
    value: 7,
    label: 'Xe đầu kéo'
  },
  {
    value: 8,
    label: 'Xe 4 chỗ'
  },
  {
    value: 9,
    label: 'Xe bê tông'
  },
  {
    value: 10,
    label: 'Xe ben đá'
  },
  {
    value: 11,
    label: 'Xe ben cát'
  },
  {
    value: 12,
    label: 'Xe ben'
  },
  {
    value: 13,
    label: 'Xe tải 1'
  },
  {
    value: 14,
    label: 'Xe tải 5'
  },
  {
    value: 15,
    label: 'Xe tải 10'
  },
  {
    value: 16,
    label: 'Xe tải 15'
  },
  {
    value: 17,
    label: 'Xe tải 20'
  },
  {
    value: 18,
    label: 'Xe tải 30'
  },
  {
    value: 29,
    label: 'Máy bay B777'
  }
];

// Màu sắc option chọn màu
export const COLORS = [
  '#1E88E5', // xanh biển 0
  '#34C5FA', // xanh da trời 1
  '#00ACC1', // da trời nhạt 2
  '#337AB7', // xanh đậm 3
  '#D81B60', // hồg đậm 4
  '#8E24AA', // violent nhạt tím 5
  '#5E35B1', // violent chính 6
  '#00897B', // xanh rêu 7
  '#43A047', // xanh lá vừa 8
  '#F4511E', // cam đỏ 9
  '#FB8C00', // cam vàng 10
  '#475865', // xám cua 11
  '#EB1D36', // đỏ 12
  '#6edeec', // da trời đậm 13
  '#285b57', // rêu đậm 14
  '#114945', // rêu rất đậm 15
  '#b1c0a6', // rêu nhạt trắng 16
  '#f37373', // đỏ phấn 17
  '#906051', // vàng đất 18
  '#98b574', // xanh lá nhạt 19
  '#E5881E', // cam đậm 20
  '#881EE5', // tím đậm 21
  '#177245', // xanh lá đậm 22
  '#657ec8', // xanh cua nhạt 23
  '#1a209e', // xanh biển đậm 24
  '#1f6b2c', // xanh lá đậm 25
  '#325ec8', // xanh biển vừa 26
  '#5f901b', // xanh lá live 27
  '#3949AB', // xanh lam đậm đen 28
  '#7CB342', // xanh lá tươi đậm 29
  '#B7B7B7', // xám vừa vừa 30
  '#445962', // xám đậm đậm 31
  '#ffffff', // trắng 32
  '#000000', // đen 33
  '#ffd500', // vàng đậm chút 34
  '#ccaa00', // vàng tươi 35
  '#444444' // nâu đậm
];

// Màu sắc option cho cảnh bảo ở table
export const COLORS_ALERT = [
  '#1E88E5', // xanh biển 0
  '#34C5FA', // xanh da trời 1
  '#00ACC1', // da trời nhạt 2
  '#337AB7', // xanh đậm 3
  '#D81B60', // hồg đậm 4
  '#8E24AA', // violent nhạt tím 5
  '#00897B', // xanh rêu 6
  '#43A047', // xanh lá vừa 7
  '#F4511E', // cam đỏ 8
  '#FB8C00', // cam vàng 9
  '#EB1D36', // đỏ 10
  '#ffd500', // vàng đậm chút 11
  '#ccaa00', // vàng tươi 12
  '#6edeec', // da trời đậm 13
  '#445962', // xám đậm đậm 14
  '#b1c0a6', // rêu nhạt trắng 15
  '#B7B7B7', // xám vừa vừa 16
  '#f37373', // đỏ phấn 17
  '#906051', // vàng đất 18
  '#98b574', // xanh lá nhạt 19
  '#E5881E', // cam đậm 20
  '#881EE5', // tím đậm 21
  '#657ec8', // xanh cua nhạt 22
  '#1f6b2c', // xanh lá đậm 23
  '#325ec8', // xanh biển vừa 24
  '#5f901b', // xanh lá live 25
  '#3949AB', // xanh lam đậm đen 26
  '#7CB342' // xanh lá tươi đậm 27
];
